<template>
  <div class="word_6">
          <div class="a4">
      <h1 style="font-size:44px;margin-top:200px">贵州省建筑业新技术应用示范工程</h1>
      <h1 style="font-size:44px;letter-spacing: 24px;">申报表</h1>
      <h1 style="font-size:28px;">（第十五批）</h1>
      <div
        style="font-size:28px;line-height:150px;margin-top:100px;text-align:start;margin-left:100px;font-family:'仿宋'"
      >示范工程名称:{{ alldata.Project_name }}</div>
      <div
        style="font-size:28px;line-height:150px;text-align:start;margin-left:100px;font-family:'仿宋'"
      >示范工程执行单位:{{ alldata.Project_executionunit }}</div>
      <div
        style="font-size:28px;line-height:150px;text-align:start;margin-left:100px;font-family:'仿宋'"
      >申报地区(部门):{{ alldata.Declaration_area }}</div>
    </div>
    <div class="a4">
      <p style="font-size:30px;line-height:140px">贵州省住房和城乡建设厅制</p>
      <div class="th">
        <div class="box" style="width:200px;height:50px;line-height:50px">示范工程名称</div>
        <div class="box" style="width:521px;height:50px">{{ alldata.Project_name2 }}</div>
      </div>
      <div class="th">
        <div class="box" style="width:200px;height:50px;line-height:50px">建 筑 面 积</div>
        <div class="box" style="width:200px;height:50px">{{ alldata.buil }}</div>
        <div class="box" style="width:180px;height:50px;line-height:50px">开工、竣工日期</div>
        <div class="box" style="width:143px;height:50px">{{ alldata.up_area }}</div>
      </div>
      <div class="th">
        <div
          class="box"
          style="width:420px;height:50px;line-height:50px;text-align:start;padding-left:10px"
        >建 筑 面 积</div>
        <div class="box" style="width:301px;height:50px">{{ alldata.up_area }}</div>
      </div>
      <div class="th">
        <div
          class="box"
          style="width:420px;height:50px;line-height:50px;text-align:start;padding-left:10px"
        >示范工程负责人姓名、职务、电话</div>
        <div class="box" style="width:301px;height:50px">{{ alldata.name }} {{ alldata.postion1 }} {{ alldata.phone1 }}</div>
      </div>
      <div class="th">
        <div
          class="box"
          style="width:420px;height:50px;line-height:50px;text-align:start;padding-left:10px"
        >示范工程技术负责人姓名、职务、电话</div>
        <div class="box" style="width:301px;height:50px">{{ alldata.name2 }} {{ alldata.postion2 }} {{ alldata.phone2 }}</div>
      </div>
      <div class="th">
        <div
          class="box"
          style="width:120px;height:50px;line-height:50px;text-align:start;padding-left:10px"
        >通讯地址</div>
        <div class="box" style="width:350px;height:50px">{{ alldata.address }}</div>
        <div
          class="box"
          style="width:120px;height:50px;line-height:50px;text-align:start;padding-left:10px"
        >邮政编码</div>
        <div class="box" style="width:133px;height:50px">{{ alldata.code }}</div>
      </div>
      <div class="th">
        <div
          class="box"
          style="width:720px;height:50px;line-height:50px;text-align:start;padding-left:10px"
        >工程概况</div>
      </div>
      <div class="th">
        <div class="box" style="width:720px;height:760px;text-align:start;padding-left:10px">{{ alldata.Project_overview.value }}</div>
      </div>
    </div>
    <div class="a4">
      <div class="th">
        <div
          class="box"
          style="width:720px;height:50px;line-height:50px;text-align:start;padding-left:10px"
        >拟推广新技术项目名称、应用部位及应用数量</div>
      </div>
      <div class="th">
        <div class="box" style="width:720px;height:1180px;text-align:start;padding-left:10px">{{ alldata.meesage1.value }}</div>
      </div>
    </div>
    <div class="a4">
      <div class="th">
        <div
          class="box"
          style="width:720px;height:50px;line-height:50px;text-align:start;padding-left:10px"
        >拟组织技术攻关和创新的项目及内容</div>
      </div>
      <div class="th">
        <div class="box" style="width:720px;height:360px;text-align:start;padding-left:10px">{{ alldata.meesage2.value }}</div>
      </div>
      <div class="th">
        <div
          class="box"
          style="width:720px;height:50px;line-height:50px;text-align:start;padding-left:10px"
        >工程进度计划</div>
      </div>
      <div class="th">
        <div class="box" style="width:720px;height:360px;text-align:start;padding-left:10px">{{ alldata.meesage3.value }}</div>
      </div>
      <div class="th">
        <div
          class="box"
          style="width:720px;height:50px;line-height:50px;text-align:start;padding-left:10px"
        >预期经济效益和社会效益</div>
      </div>
      <div class="th">
        <div class="box" style="width:720px;height:360px;text-align:start;padding-left:10px">{{ alldata.meesage4.value }}</div>
      </div>
    </div>
    <div class="a4">
      <div class="th">
        <div
          class="box"
          style="width:720px;height:50px;line-height:50px;text-align:start;padding-left:10px"
        >示范工程执行单位意见</div>
      </div>
      <div class="th">
        <div
          class="box"
          style="width:720px;height:570px;text-align:start;padding-left:10px;position: relative;"
        > {{ alldata.meesage5.value }}
          <div style="position: absolute;right:80px;bottom:60px">
            <p>(公章)</p>
            <br />
            <p>年 月 日</p>
          </div>
        </div>
      </div>
      <div class="th">
        <div
          class="box"
          style="width:720px;height:50px;line-height:50px;text-align:start;padding-left:10px"
        >申报地区(部门)意见</div>
      </div>
      <div class="th">
        <div
          class="box"
          style="width:720px;height:570px;text-align:start;padding-left:10px;position: relative;"
        > {{ alldata.meesage6.value }}
          <div style="position: absolute;right:80px;bottom:60px">
            <p>(公章)</p>
            <br />
            <p>年 月 日</p>
          </div>
        </div>
      </div>
    </div>
    <div class="a4">
      <div class="th">
        <div
          class="box"
          style="width:720px;height:50px;line-height:50px;text-align:start;padding-left:10px"
        >专家评审意见</div>
      </div>
      <div class="th">
        <div
          class="box"
          style="width:720px;height:570px;text-align:start;padding-left:10px;position: relative;"
        > {{ alldata.meesage7.value }}
          <div style="position: absolute;right:80px;bottom:60px">
            <p>(公章)</p>
            <br />
            <p>年 月 日</p>
          </div>
        </div>
      </div>
      <div class="th">
        <div
          class="box"
          style="width:720px;height:50px;line-height:50px;text-align:start;padding-left:10px"
        >省住建厅审批意见</div>
      </div>
      <div class="th">
        <div
          class="box"
          style="width:720px;height:570px;text-align:start;padding-left:10px;position: relative;"
        > {{ alldata.meesage8.value }}
          <div style="position: absolute;right:80px;bottom:60px">
            <p>(公章)</p>
            <br />
            <p>年 月 日</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props:{
    alldata:{
      type:Object
    }
  }
}
</script>

<style lang="less" scoped>
  .a4 {
    padding: 50px 60px 50px 60px;
    width: 842px;
    height: 1346px;
    margin: 0 auto;
    margin-top: 32px;
    background: #ffffff;
    box-sizing: border-box;
    color: black;
    box-shadow: 0px 12px 22px rgba(0, 0, 0, 0.16);
    p,
    h1 {
      font-family: "仿宋";
    }
    .th {
      display: flex;
      align-items: center;
      font-family: "仿宋";
    }
    .box {
      box-sizing: border-box;
      border: 1px solid black;
      margin: 0 -1px -1px 0;
      text-align: center;
      font-size: 20px;
    }
    .position {
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
    }
  }
</style>